var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('h1',{staticClass:"has-text-weight-semibold"},[_vm._v("Molecular structure:")]),_c('img',{staticClass:"image",staticStyle:{"min-width":"200px","max-width":"280px"},attrs:{"src":_vm.image,"alt":"Molecular structure image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }